import { Navigate, Outlet } from 'react-router-dom';
import React from 'react';

import { useUserProfileUIStore, useUserPermissionsUIStore } from '@core/useStores';
import { RoutePaths } from '@core/routes/RoutePaths';
import { PagesRoutes } from '@core/routes/PagesRoutes';
import { PagesNames } from '@core/routes/PagesNames';

interface RoutePropsExtended {
    page: string;
    children?: React.ReactNode;
};

export const ProtectedRoute = () => {
    const userProfileUIStore = useUserProfileUIStore();

    return (
        userProfileUIStore.isAuthentificated
            ? <Outlet />
            // The search string matters: /pair?code=XXXXXX is a whole entry point, and dropping
            // the query would land the user on an empty form after signing in.
            : <Navigate to={{ pathname: RoutePaths.login}} state={ {from: location.pathname + location.search} } />
    );
}

export const ProtectedPage: React.FC<RoutePropsExtended> = ({ page, children }: RoutePropsExtended) => {
    const userProfileUIStore = useUserProfileUIStore();
    const userPermissionsUIStore = useUserPermissionsUIStore();

    const isPageAvailable = userPermissionsUIStore.isPageAvailable(page);
    const firstAvailablePage = userPermissionsUIStore.firstAvailablePage;

    return (
        userProfileUIStore.isAuthentificated
            ? isPageAvailable
                ? <>{children}</>
                : (
                    <Navigate
                        to={{
                            pathname: PagesRoutes.get(firstAvailablePage || PagesNames.Login),
                        }}
                        replace
                    />
                )
            : (
                <Navigate
                    to={{
                        pathname: RoutePaths.login,
                    }}
                    // state={{ from: location }}
                />
            )
    );
}
